module.exports = __webpack_public_path__ + "static/media/welcome.e11984f0.jpg";